export default "__VITE_ASSET__2266df9d__"